import React from "react";

import { Button as AntButton, ButtonProps as AntButtonProps } from "antd";

import { ProductEventProps, goTo, productAnalytics, trackMixpanel, useNavigate } from "utils";

export type LinkProps = Omit<AntButtonProps, "type"> &
  ProductEventProps & {
    dataTestId?: string;
    mixpanelText?: string;
    to?: string;
    state?: Record<string, unknown>;
    type?: "primary-link" | "secondary-link" | "tertiary-link";
    tracking?: boolean;
  };

export const Link = ({
  dataTestId,
  children,
  className,
  mixpanelText,
  productEvent,
  productEventProperties,
  state,
  target,
  to,
  type,
  onClick,
  tracking = true,
  ...props
}: LinkProps) => {
  const navigate = useNavigate();

  return (
    <AntButton
      {...props}
      data-testid={dataTestId}
      href={to}
      type="link"
      className={className ?? type}
      onClick={(e) => {
        if (tracking) {
          trackMixpanel("ClickLink", {
            linkText: mixpanelText || (typeof children === "string" && children) || "undefined",
            link: to,
          });
        }
        if (productEvent) productAnalytics.track(productEvent, productEventProperties);
        if (to) {
          goTo(e, navigate, to, target && target === "_blank", state ? { state } : null);
        }
        onClick?.(e);
      }}
    >
      {children}
    </AntButton>
  );
};

export default Link;
